import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FooterComponent} from "./footer.component";
import { AgmCoreModule } from '@agm/core';
import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';


@NgModule({
  imports: [
    CommonModule, AgmCoreModule, AgmSnazzyInfoWindowModule
  ],
  declarations: [FooterComponent],
  exports: [FooterComponent]
})
export class FooterModule { }



// WEBPACK FOOTER //
// ./src/app/layouts/footer/footer.module.ts